import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6977dc0e921dc900146d9d6d/subaylar_construction/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6977dc0e921dc900146d9d6d/subaylar_construction/src/styles/index.css");
